import axios from 'axios';
import { gsap } from 'gsap';

const loadButton = document.querySelector('#product-search-btn');
const searchForm = document.querySelector('#product-search');
const siteURL = routingData.siteURL;

const dummyData = [
	{
		image_url:
			siteURL +
			'/wp-content/themes/catalyst/assets/images/products/TC_Device-Images_0019_PS5.png',
		link: siteURL + '/get-a-quote/?manufacturer=1&deviceType=1&device=1',
		heading: 'Sample Heading 1',
	},
	{
		image_url:
			siteURL +
			'/wp-content/themes/catalyst/assets/images/products/TC_Device-Images_0019_PS5.png',
		link: siteURL + '/get-a-quote/?manufacturer=1&deviceType=1&device=1',
		heading: 'Sample Heading 2',
	},
	{
		image_url:
			siteURL +
			'/wp-content/themes/catalyst/assets/images/products/TC_Device-Images_0019_PS5.png',
		link: siteURL + '/get-a-quote/?manufacturer=1&deviceType=1&device=1',
		heading: 'Sample Heading 3',
	},
	{
		image_url:
			siteURL +
			'/wp-content/themes/catalyst/assets/images/products/TC_Device-Images_0019_PS5.png',
		link: siteURL + '/get-a-quote/?manufacturer=1&deviceType=1&device=1',
		heading: 'Sample Heading 4',
	},
];

const ajaxLoadDevices = () => {
	let searchInput = searchForm.querySelector('input');
	let outputContainer = document.querySelector('.results-output');

	outputContainer.innerHTML = '<div class="loadbar">Loading Devices</div>';

	// const postData = () => {
	let params = new URLSearchParams();
	params.append('action', 'device_search');
	params.append('products', JSON.stringify(dummyData));

	axios
		.post('/wp-admin/admin-ajax.php', params)
		.then((res) => {
			outputContainer.innerHTML = res.data.data;
		})
		.then(() => {
			// Load in new elements with fade
			let loadedItems = document.querySelectorAll('.loaded-ajax');

			let hiddenSearchElement = document.querySelectorAll(
				'.hidden-search-element'
			);

			Array.from(loadedItems).forEach((item) => {
				setTimeout(() => {
					item.classList.remove('loaded-ajax');
				}, 50);
			});

			Array.from(hiddenSearchElement).forEach((el) => {
				setTimeout(() => {
					el.classList.remove('hidden-search-element');
				}, 50);
			});
		});
};

document.addEventListener('DOMContentLoaded', () => {
	if (typeof loadButton != 'undefined' && loadButton != null) {
		loadButton.addEventListener('click', (e) => {
			e.preventDefault();
			ajaxLoadDevices('load', false);
		});
	}

	if (typeof searchForm != 'undefined' && searchForm != null) {
		searchForm.addEventListener('submit', (e) => {
			e.preventDefault();
			ajaxLoadDevices('load', false);
		});
	}
});
